import type { FaireProductEntity } from "../../entity_types/product";

export const p_9vxv4ftn42: FaireProductEntity = {
  token: "p_9vxv4ftn42",
  type: "product",
  name: "Witch Herb Spoon.",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/8c1e95d4dd7a7b52136c37b5ae3a715b043c7220e99009ffb308ea4fa23e7346.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a82b69c841bd5f8fe3086d0228f991b9e068b6874901408a62c46430b5d63d42.jpeg",
    "https://cdn.faire.com/fastly/17f9096299161116afaa11ed5bbc83f11d5ff99f656fa967a1e689c4f09eae93.jpeg",
    "https://cdn.faire.com/fastly/10264ff9966df39c7e7acb7fc6f8bff8eec8bb25daa9c2ea1f6e2cf9d99b17c6.jpeg",
    "https://cdn.faire.com/fastly/d6ea200348de991ff0767951a51bdfa423de0e1f5ba1ff6aa903b19326669d7d.jpeg",
    "https://cdn.faire.com/fastly/8693ff996e6769af7aa38c18bfa17d09e51e2a3801bc3a72cf1166861a038e67.jpeg",
    "https://cdn.faire.com/fastly/837c129384b9cf4c3d1cfb862ed52345e87178c6520329088a92834f1acfbde9.jpeg",
    "https://cdn.faire.com/fastly/8c243531bf73b9904d440cd51d218179c170d1f6e98c54fbe7acea094c6051a5.jpeg",
    "https://cdn.faire.com/fastly/1f5c67bd8b10700bad9e9d783f735483b015307a851f19bf68e95b0954673f7c.jpeg",
    "https://cdn.faire.com/fastly/1891a27161027f7e23c4af1c89b07a4ddb14e84652ea098301d1e3f4038f782d.jpeg",
    "https://cdn.faire.com/fastly/9e153efb6e17f7a780121e3217cefba13e1fbaa389406a6b722ad9eb9745b030.jpeg",
    "https://cdn.faire.com/fastly/eac21b0ef1fe3d954604893706b5ef315c11265f627de799a8598dafccb75ec9.jpeg",
    "https://cdn.faire.com/fastly/e4e9542c149443bb5350c77d30dd35280df39f3a98cd0ed95f0d771dcb66eb77.jpeg",
    "https://cdn.faire.com/fastly/c32a4ecab9dc300918f73fd3e17384ce1ec9df161800cc7030c11ba977361876.jpeg",
    "https://cdn.faire.com/fastly/5ef26a5e4de742baf65b24b3e145ed14a2a01dcd5c9715af6936246c92462623.jpeg",
    "https://cdn.faire.com/fastly/a0f39e9df529415ac2899a816e14dff2cbbe7f7ee95412f1bb9e0311a5748b7d.jpeg",
    "https://cdn.faire.com/fastly/1b8ca93c8768cf732a6b73327b4268cddf93a23c0257a6ef504a6519fae8ff95.jpeg",
    "https://cdn.faire.com/fastly/c100ad925499f21ea90e678629740fd4fdc291bd164663bcb24a952ca813c23d.jpeg",
    "https://cdn.faire.com/fastly/3f761ab5175f3fd6726185f50098f335831bb05d49ef8578e656aaf596bd3c14.jpeg",
    "https://cdn.faire.com/fastly/e8ff973c714c85ca6264cc655860bed71dd22bf4a0c95bbe9af8b27b7b9321bb.jpeg",
    "https://cdn.faire.com/fastly/1ba0a4088b34a0f75f18b4c8f663143607eb0cc1d1b0577b9c01a57bac04d4a5.jpeg",
    "https://cdn.faire.com/fastly/dd95eaeffff89142472f2774177c025f4d5172b5d65836c9bdfc5907f486ffd8.jpeg",
    "https://cdn.faire.com/fastly/82dcfb0b8bf877243404956c584b25e88772e85821a8f26988c11f98a38cc1cf.jpeg",
  ],
  priceDollars: 3.46,
  description:
    "This 4.5” Witch Herb Spoon features a detailed floral spoon bowl and a branch-style handle topped with a raw crystal. Available in silver, gold, or rose gold finishes, each spoon is accented with natural stones like Amethyst, Green Aventurine, Sodalite, Clear Quartz, etc. Perfect for scooping herbs, incense, or ritual blends, it’s a simple yet beautiful addition to any altar or apothecary space. Because the crystals are natural, each one will vary slightly in shape and color.\n\n * 4.5” Length\n\n * Assorted Stones ",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:49.438Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
